import { CmsComponentsBase } from '@/cmsComponents/base';
import { CmsComponentsPress } from '@/cmsComponents/press';

const cmsComponents = {
  ...CmsComponentsBase,
  ...CmsComponentsPress,
};

export default cmsComponents;
